"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TabContext = require("../contexts/TabContext");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function RecoveryEmailSent() {
  var _useContext = (0, _react.useContext)(_TabContext.TabContext),
    setTab = _useContext.setTab;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form-textBox"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "Auth-right-form-highlight"
  }, "Email enviado!"), /*#__PURE__*/_react["default"].createElement("p", null, "Verifique a caixa de entrada do seu email e siga as instru\xE7\xF5es para acesso e controle da sua conta!"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Auth-right-form-centeredText"
  }, "N\xE3o \xE9 aqui?", " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-link",
    onClick: function onClick() {
      return setTab("login");
    }
  }, "Voltar \xE0 tela de login"))));
}
var _default = RecoveryEmailSent;
exports["default"] = _default;